import {Component, Input} from '@angular/core';

@Component({
    selector: 'ui-key',
    templateUrl: './ui-key.component.html',
    styleUrls: ['./ui-key.component.scss'],
    standalone: false
})
export class UiKeyComponent {
    @Input() key: string;
    @Input() mouse: 'left' | 'right' | 'middle' | null = null;
}
